import React from "react";

const LogoTop = () => {
    return (
        <div>
            <p style={{ fontSize: 14, color: '#68E8E5', textAlign: 'center'}}>RENTVROOM</p>
        </div>
    );
  };
  
  export default LogoTop;